import { ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser, type PreferredLanguageEnum } from '@/types/generated'
import { useLocaleStore, preferredLanguageToLocale, supportedLocales } from './localStore'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response

      // Apply user's preferred language if set
      if (response.preferred_language) {
        const localeStore = useLocaleStore()
        const locale =
          preferredLanguageToLocale[response.preferred_language as PreferredLanguageEnum]

        if (locale && supportedLocales.includes(locale)) {
          localeStore.setLocale(locale)
        }
      }

      return response
    } catch (error) {
      return null
    }
  }

  return {
    user,
    fetchUser
  }
})
